import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'vue-material-design-icons/styles.css'
import Toolbar from './components/core/Toolbar.vue'
import Navigation from './components/core/NavigationDrawer.vue'
import Breadcrumbs from './components/core/Breadcrumbs.vue'
import axios from 'axios'
import Cookies from 'vue-cookies'
// import Pusher from 'vue-pusher'
// import VueVideoPlayer from 'vue-video-player'
// require videojs style
// import 'video.js/dist/video-js.css'
import VueFusionCharts from 'vue-fusioncharts'
import FusionCharts from 'fusioncharts'
import Column2D from 'fusioncharts/fusioncharts.charts'
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'

Vue.config.productionTip = false
Vue.use(VueSweetalert2)
Vue.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme)
Vue.use(Cookies)
// Vue.use(Pusher, { api_key: '4712576b9399184b6792', options: { cluster: 'us3', encrypted: true } })

Vue.component('toolbar', Toolbar)
Vue.component('navigation', Navigation)
Vue.component('breadcrumbs', Breadcrumbs)

axios.defaults.baseURL = 'https://sigs4-bend.deersystems.mx/'
// axios.defaults.baseURL = 'https://sts-bend.deersystems.mx/'
// axios.defaults.baseURL = 'http://sigs.dev.local/'
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
